import classNames from "classnames";
import {  PlayerPublic } from "../../models/Player";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../hooks/redux";
import { FALLBACK_AVATAR } from "../../utils/enums";

export default function PlayerPicture(props: {
  player:Partial<PlayerPublic> | null,
  size?: number,
  hideInitials?: boolean,
  classes?: string,
}) {

  const { player, size = 50, classes, hideInitials = false } = props;
  const tooltipState = useAppSelector((state: RootState) => state.tooltip);

  const playerClasses = classNames({
    'player_picture': true,
  }, classes);

  function onError(e: any, picture: string | undefined) {
    console.error(`cannot fetch avatar: ${picture}`);
    e.target.src = FALLBACK_AVATAR;
  }

  function getMiddle(s: string, length: number = 1) {
    let position;
    if (s.length % 2) {
      position = s.length / 2;
    } else {
      position = s.length / 2 - 1;
    }
    return s.substring(position, position + length);
  }

  function getInitials(username: string) {
    if (!username) {
      return '';
    }
    if (username.length <= 3) {
      return username;
    }

    //return username.substring(0,3);

    let initials = '';
    initials += username[0];
    initials += username[1];
    //initials += getMiddle(username);
    initials += username[username.length - 1]
    return initials;
  }

  return (
      <div className={playerClasses}>
        {player && <>
          <img onError={(e) => onError(e, player?.picture)} src={player.picture || FALLBACK_AVATAR} width={size} height={size} alt={player.username} />
          <div className="loader"></div>
          {player && !props.hideInitials && <div className="player_initials no-user-select">{getInitials(player?.username || '')}</div>}
        </>
        }
      </div>
  )
}